module.exports = __webpack_public_path__ + "img/home.f8290c3b.png";